import { Controller } from "@hotwired/stimulus"
import ApexCharts from "apexcharts"

export default class extends Controller {
  static values = {
    data: Object
  }

  connect() {
    this.chart = new ApexCharts(
      this.element,
      this.options
    )

    this.chart.render()
  }

  disconnect() {
    this.chart?.destroy()
  }

  get options() {
    return {
      chart: {
        type: "area",
        height: 250,
        toolbar: {
          show: false
        },
        zoom: {
          enabled: true
        }
      },

      dataLabels: {
        enabled: false
      },

      stroke: {
        curve: "smooth"
      },

      xaxis: {
        categories: this.dataValue.categories
      },

      series: this.dataValue.series
    }
  }
}